const styles = (theme) => ({
  loader: {
    fill: theme.palette.primary.red,
    color: theme.palette.primary.red,
  },
});

export default styles;
